// src/pages/Parametros/tabs/TabCor.jsx
import React from 'react';
import {
    Box, TextField, Switch, FormControlLabel,
    Typography, Paper, Select, MenuItem,
    FormControl, InputLabel, InputAdornment,
    IconButton, Button, Divider,
} from '@mui/material';
import * as Lucide from 'lucide-react';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

const TIPO_GRAFICO_OPTIONS = [
    { value: 'SPECTRAL_TURBIDIMETRY', label: 'Turbidimetria' },
    { value: 'SPECTRAL_NEPHELOMETRY', label: 'Nefelometria' },
    { value: 'SPECTRAL_FLUORESCENCE', label: 'Fluorescência' },
];

const NOVO_ITEM = {
    tipoGrafico: 'SPECTRAL_TURBIDIMETRY',
    ativarValidacaoCor: true,
    minPontosValidos: 10,
    minVarianciaCor: 5,
};

export default function TabCor() {
    const { params, updateGroup } = useParametrosAnalise();
    const lista = params.cor ?? [];

    const setItem = (index, field, value) => {
        const next = lista.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        updateGroup('cor', next);
    };

    const addItem = () => updateGroup('cor', [...lista, { ...NOVO_ITEM }]);

    const removeItem = (index) =>
        updateGroup('cor', lista.filter((_, i) => i !== index));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 3 }}>

            <Typography variant="body2" color="text.secondary">
                Configure a validação espectral por tipo de gráfico. Cada entrada define critérios independentes.
            </Typography>

            {lista.map((item, index) => (
                <Paper key={item.tipoGrafico ?? index} variant="outlined" sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="subtitle2" fontWeight={600}>
                            {TIPO_GRAFICO_OPTIONS.find(o => o.value === item.tipoGrafico)?.label ?? item.tipoGrafico}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        size="small"
                                        checked={item.ativarValidacaoCor}
                                        onChange={(e) => setItem(index, 'ativarValidacaoCor', e.target.checked)}
                                    />
                                }
                                label={item.ativarValidacaoCor ? 'Ativo' : 'Inativo'}
                            />
                            <IconButton size="small" color="error" onClick={() => removeItem(index)}>
                                <Lucide.Trash2 size={18} />
                            </IconButton>
                        </Box>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        <FormControl sx={{ width: 220 }} disabled={!item.ativarValidacaoCor}>
                            <InputLabel>Gráfico</InputLabel>
                            <Select
                                value={item.tipoGrafico}
                                label="Gráfico"
                                onChange={(e) => setItem(index, 'tipoGrafico', e.target.value)}
                            >
                                {TIPO_GRAFICO_OPTIONS.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            label="Mínimo de pontos válidos"
                            type="number"
                            value={item.minPontosValidos}
                            onChange={(e) => setItem(index, 'minPontosValidos', Number(e.target.value))}
                            inputProps={{ min: 1 }}
                            sx={{ width: 210 }}
                            helperText="Pontos não-nulos da API de cor"
                            disabled={!item.ativarValidacaoCor}
                        />

                        <TextField
                            label="Variância mínima"
                            type="number"
                            value={item.minVarianciaCor}
                            onChange={(e) => setItem(index, 'minVarianciaCor', Number(e.target.value))}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            inputProps={{ min: 0, max: 100, step: 0.1 }}
                            sx={{ width: 180 }}
                            helperText="Amplitude mínima sRGB"
                            disabled={!item.ativarValidacaoCor}
                        />
                    </Box>
                </Paper>
            ))}

            <Box>
                <Button
                    startIcon={<Lucide.Plus />}
                    onClick={addItem}
                    variant="outlined"
                    size="small"
                >
                    Adicionar gráfico
                </Button>
            </Box>
        </Box>
    );
}
